import {environment} from '../../../../environments/environment';

export class AppCheck {
  static isInitialized = false;

  static async getToken(): Promise<string | null> {
    if (!environment.enableAppCheck) {
      return null;
    }

    const {FirebaseAppCheck} = await import(
      /* webpackChunkName: "@capacitor-firebase/app-check" */ '@capacitor-firebase/app-check'
    );
    if (!AppCheck.isInitialized) {
      const debugToken = (environment as any).appCheckDebugToken || !environment.production;
      if (typeof debugToken === 'string') {
        (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
      }
      await FirebaseAppCheck.initialize({siteKey: environment.reCAPTCHAKey, debug: !!debugToken});
      AppCheck.isInitialized = true;
    }
    const {token} = await FirebaseAppCheck.getToken({forceRefresh: false});
    return token;
  }
}
